import { ArcheResultCard } from './ArcheResultCard';

interface ArcheResult {
  archId: string;
  slug?: string | null;
  name: string;
  simpleDescription: string;
  imageRef: string | null;
}

interface ArcheResultsBlockProps {
  results: ArcheResult[];
  totalResults: number;
  onArcheClick: (archId: string) => void;
}

export function ArcheResultsBlock({ results, totalResults, onArcheClick }: ArcheResultsBlockProps) {
  if (results.length === 0) return null;

  return (
    <div className="ml-11 space-y-3 mt-2">
      {results.map((arche) => (
        <ArcheResultCard
          key={arche.archId}
          arche={arche}
          onClick={() => onArcheClick(arche.slug || arche.archId)}
        />
      ))}
      {totalResults > results.length && (
        <p className="text-sm text-muted-foreground mt-2">
          +{totalResults - results.length} more results in the sidebar
        </p>
      )}
    </div>
  );
}
